// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueFire from 'vuefire';
import VueAnalytics from 'vue-analytics';
import App from './App';
import router from './router';

Vue.use(VueAnalytics, {
  id: 'UA-344672-41',
  router,
});

Vue.config.productionTip = false;
Vue.use(VueFire);

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App />',
});

export default vm;

(function (document, script) {
    var ptallscripts = document.getElementsByTagName(script)[0],
        ptscript = document.createElement(script);
    ptscript.async = true;
    ptscript.src = "https://portrait-tracker.s3.amazonaws.com/all.js";
    ptallscripts.parentNode.insertBefore(ptscript, ptallscripts);
})(document, "script");
document.addEventListener('portraitReady', function (e) { 
    Portrait.staticTracker();
    dataLayer.push({
      'event': 'event_triggered',
      'event_category' : 'PWS Livestream Video',
      'event_action' : 'Watched'
    });
}, false);


// WEBPACK FOOTER //
// ./src/main.js